<div class="purchase-flow-wrapper" (appClickOutside)="closePopup()">
  <div class="popup-wrapper">
    <div class="popup-wrapper--header">
      <div class="popup-wrapper--title">
        {{ pageTitle[currentStep] }}
      </div>
      <button class="popup--close" [disabled]="loading" (click)="closePopup()">
        <svg class="popup--close-icon" viewBox="0 0 32 32">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.35241 5.27713C5.72062 4.90764 6.31761 4.90764 6.68582 5.27713L26.7238 25.3848C27.0921 25.7543 27.0921 26.3534 26.7238 26.7229C26.3556 27.0924 25.7587 27.0924 25.3904 26.7229L5.35241 6.61517C4.98421 6.24568 4.98421 5.64662 5.35241 5.27713Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.27616 26.6857C4.90795 26.3162 4.90795 25.7172 5.27616 25.3477L25.2772 5.27712C25.6454 4.90763 26.2424 4.90763 26.6106 5.27712C26.9788 5.64661 26.9788 6.24567 26.6106 6.61516L6.60956 26.6857C6.24135 27.0552 5.64437 27.0552 5.27616 26.6857Z"
          />
        </svg>
      </button>
      <div
        class="purchase-flow--steps"
        *ngIf="currentStep !== PurchaseFlowSteps.EditImage"
      >
        <app-wizard-steps
          [steps]="steps"
          [activeStep]="PurchaseFlowSteps[currentStep]"
        ></app-wizard-steps>
      </div>
    </div>
    <div class="popup-wrapper--body">
      <div class="popup-wrapper--body-in">
        <div class="purchase-flow--content">
          <ng-container [ngSwitch]="currentStep">
            <ng-container *ngSwitchCase="PurchaseFlowSteps.Tile">
              <app-tiles [tilesSize]="tilesSize"></app-tiles>
            </ng-container>
            <ng-container *ngSwitchCase="PurchaseFlowSteps.ChooseImage">
              <app-choose-image
                [formGroupRef]="purchaseFlowService.nftArtFormGroup"
                (handleImageSelect)="imageSelectHandler($event)"
              ></app-choose-image>
            </ng-container>
            <ng-container *ngSwitchCase="PurchaseFlowSteps.EditImage">
              <app-choose-image
                [editMode]="true"
                [formGroupRef]="purchaseFlowService.nftArtFormGroup"
                (handleImageSelect)="imageSelectHandler($event)"
              ></app-choose-image>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="popup-wrapper--footer w-btn--wrap">
      <button
        *ngIf="currentStep !== PurchaseFlowSteps.EditImage"
        class="w-btn w-btn--secondary"
        (click)="previousStep()"
        [disabled]="loading"
      >
        {{ currentStep === PurchaseFlowSteps.Tile ? "Close" : "Back" }}
      </button>
      <button
        (click)="nextStep()"
        [class.w-btn--loading]="loading"
        [disabled]="
          currentStep === PurchaseFlowSteps.ChooseImage &&
          !purchaseFlowService.selectedAssetId
        "
        class="w-btn w-btn--primary"
      >
        <ng-container [ngSwitch]="currentStep">
          <ng-container *ngSwitchCase="PurchaseFlowSteps.Tile"
            >Next</ng-container
          >
          <ng-container *ngSwitchCase="PurchaseFlowSteps.ChooseImage"
            >Add to cart</ng-container
          >
          <ng-container *ngSwitchCase="PurchaseFlowSteps.EditImage"
            >Save</ng-container
          >
        </ng-container>
        <div *ngIf="loading" class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </button>
    </div>
  </div>
</div>
